// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falL: CreateIconOptions = {
  "displayName": "FALL",
  "viewBox": "0, 0, 320, 512",
  "d": "M48 32c8.8 0 16 7.2 16 16l0 400 240 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 480c-8.8 0-16-7.2-16-16L32 48c0-8.8 7.2-16 16-16z"
};
